import type { Transcript } from "../types";
import { formatTimestamp } from "./helpers";

export type TranscriptExportFormat = "txt" | "md";

function segmentSpeaker(speaker: string | null): string {
  return speaker?.trim() || "Speaker";
}

export function transcriptToText(transcript: Transcript): string {
  const lines = transcript.segments.map(
    (segment) =>
      `[${formatTimestamp(segment.start)}] ${segmentSpeaker(segment.speaker)}: ${segment.text}`,
  );
  return [transcript.name, "", ...lines].join("\n");
}

export function transcriptToMarkdown(transcript: Transcript): string {
  const lines = transcript.segments.flatMap((segment) => [
    `### [${formatTimestamp(segment.start)}] ${segmentSpeaker(segment.speaker)}`,
    "",
    segment.text,
    "",
  ]);
  return [`# ${transcript.name}`, "", "## Transcript", "", ...lines].join("\n").trimEnd();
}

export function transcriptFileBase(transcript: Transcript): string {
  const withoutExtension = transcript.name.replace(/\.[^./\\]+$/, "");
  const safe = withoutExtension
    .replace(/[\\/]+/g, " - ")
    .replace(/[:*?"<>|]+/g, "")
    .replace(/\s+/g, " ")
    .trim();
  return safe || `transcript-${transcript.id}`;
}

export function transcriptExportContent(
  transcript: Transcript,
  format: TranscriptExportFormat,
): string {
  return format === "md" ? transcriptToMarkdown(transcript) : transcriptToText(transcript);
}

export function transcriptExportFilename(
  transcript: Transcript,
  format: TranscriptExportFormat,
): string {
  return `${transcriptFileBase(transcript)}.${format}`;
}
